import Funnel from '../funnel/funnel.jsx';

const ErrorCSS = () => {
  return (
    <div style={{ textAlign: 'left' }}>
      <h1>CSS: Hidden Messages</h1>
      <p>When submitting the final step of the funnel below, an error message appears to the user.</p>
      <p>The code to the right takes a CSS selector, checks for a match, and logs to console TRUE or FALSE if it is found, along with the returned element</p>
      <p>We want a selector that results in a TRUE only when the error message is visible to the user, but unfortunately the selector on the right always return true. Try clicking <strong>Run</strong> with and without the error message showing to see for yourself</p>
      <p>Change the selector so it only returns TRUE when the error message is visible to the user.</p>
      <p><b>You can click "DISMISS" to close the error message to test how the code behaves when the error message is not visible.</b></p>
      
      <Funnel defaultStep={2} errorState={false}/>
    </div>
  )

}

export default ErrorCSS;